import { render, staticRenderFns } from "./social-share-links.vue?vue&type=template&id=e0df21c6&"
import script from "./social-share-links.vue?vue&type=script&lang=js&"
export * from "./social-share-links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports